import * as ɵngcc0 from '@angular/core';
var JssModule_1;
import * as tslib_1 from "tslib";
import { CommonModule, DatePipe } from '@angular/common';
import { ANALYZE_FOR_ENTRY_COMPONENTS, NgModule } from '@angular/core';
import { ROUTES } from '@angular/router';
import { DateDirective } from './components/date.directive';
import { FileDirective } from './components/file.directive';
import { GenericLinkDirective } from './components/generic-link.directive';
import { ImageDirective } from './components/image.directive';
import { LinkDirective } from './components/link.directive';
import { MissingComponentComponent } from './components/missing-component.component';
import { PlaceholderLoadingDirective } from './components/placeholder-loading.directive';
import { PlaceholderComponent } from './components/placeholder.component';
import { DYNAMIC_COMPONENT, PLACEHOLDER_COMPONENTS, PLACEHOLDER_LAZY_COMPONENTS, PLACEHOLDER_MISSING_COMPONENT_COMPONENT } from './components/placeholder.token';
import { RawComponent } from './components/raw.component';
import { RenderComponentComponent } from './components/render-component.component';
import { RenderEachDirective } from './components/render-each.directive';
import { RenderEmptyDirective } from './components/render-empty.directive';
import { RichTextDirective } from './components/rich-text.directive';
import { RouterLinkDirective } from './components/router-link.directive';
import { TextDirective } from './components/text.directive';
import { JssComponentFactoryService } from './jss-component-factory.service';
import { LayoutService } from './layout.service';
let JssModule = JssModule_1 = class JssModule {
    /**
     * Instantiates the JSS module with no component factory.
     * Useful for using it from libraries. Most of the time you'd want withComponents()
     */
    static forRoot() {
        return {
            ngModule: JssModule_1,
            providers: [
                LayoutService,
                DatePipe,
                JssComponentFactoryService,
            ],
        };
    }
    /** Instantiates a module for a lazy-loaded JSS component */
    static forChild(component) {
        return {
            ngModule: JssModule_1,
            providers: [
                { provide: ANALYZE_FOR_ENTRY_COMPONENTS, useValue: component, multi: true },
                { provide: ROUTES, useValue: [], multi: true },
                { provide: DYNAMIC_COMPONENT, useValue: component },
            ],
        };
    }
    /**
     * Instantiates the JSS module and specifies the mapping from component name to component implementation.
     * Appropriate when defining the set of JSS components that your app is aware of.
     */
    static withComponents(components, lazyComponents) {
        return {
            ngModule: JssModule_1,
            providers: [
                {
                    provide: ANALYZE_FOR_ENTRY_COMPONENTS,
                    useValue: components,
                    multi: true,
                },
                { provide: PLACEHOLDER_COMPONENTS, useValue: components },
                { provide: PLACEHOLDER_LAZY_COMPONENTS, useValue: lazyComponents || [] },
                { provide: ROUTES, useValue: lazyComponents || [], multi: true },
                { provide: PLACEHOLDER_MISSING_COMPONENT_COMPONENT, useValue: MissingComponentComponent },
                ...JssModule_1.forRoot().providers,
            ],
        };
    }
};
JssModule.ɵfac = function JssModule_Factory(t) { return new (t || JssModule)(); };
JssModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: JssModule });
JssModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(JssModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                ],
                declarations: [
                    FileDirective,
                    ImageDirective,
                    LinkDirective,
                    RouterLinkDirective,
                    GenericLinkDirective,
                    DateDirective,
                    RenderEachDirective,
                    RenderEmptyDirective,
                    PlaceholderLoadingDirective,
                    RenderComponentComponent,
                    PlaceholderComponent,
                    RawComponent,
                    RichTextDirective,
                    TextDirective,
                    MissingComponentComponent,
                ],
                exports: [
                    FileDirective,
                    ImageDirective,
                    DateDirective,
                    LinkDirective,
                    RouterLinkDirective,
                    GenericLinkDirective,
                    RenderEachDirective,
                    RenderEmptyDirective,
                    RenderComponentComponent,
                    PlaceholderComponent,
                    PlaceholderLoadingDirective,
                    RichTextDirective,
                    TextDirective,
                ],
                entryComponents: [
                    RawComponent,
                    MissingComponentComponent,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(JssModule, { declarations: function () { return [FileDirective,
        ImageDirective,
        LinkDirective,
        RouterLinkDirective,
        GenericLinkDirective,
        DateDirective,
        RenderEachDirective,
        RenderEmptyDirective,
        PlaceholderLoadingDirective,
        RenderComponentComponent,
        PlaceholderComponent,
        RawComponent,
        RichTextDirective,
        TextDirective,
        MissingComponentComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [FileDirective,
        ImageDirective,
        DateDirective,
        LinkDirective,
        RouterLinkDirective,
        GenericLinkDirective,
        RenderEachDirective,
        RenderEmptyDirective,
        RenderComponentComponent,
        PlaceholderComponent,
        PlaceholderLoadingDirective,
        RichTextDirective,
        TextDirective]; } }); })();
export { JssModule };
